import React, { useEffect, useState } from 'react';
import blogApi from '../api/blogApi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PostList = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    blogApi.get('/api/blog/posts/')
      .then(res => setPosts(res.data))
      .catch(err => console.error('게시글 목록 조회 실패:', err));
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">게시글 목록</h1>

        {isLoggedIn && (
          <button
            onClick={() => navigate('/postCreate')}
            className="bg-[#3B82F6] text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            게시물 등록
          </button>
        )}
      </div>

      <ul className="space-y-4">
        {posts.map(post => (
          <li
            key={post.id}
            className="p-4 border rounded shadow-sm bg-white hover:bg-gray-50 cursor-pointer"
            onClick={() => navigate(`/posts/${post.id}`)}
          >
            <h2 className="text-xl font-semibold">{post.title}</h2>
            <p className="text-gray-600">작성자: {post.author_name}</p>
            <p className="text-gray-400 text-sm">
              작성일: {new Date(post.created_at).toLocaleString()}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PostList;
